import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import * as tree from 'treetabular';
import { compose } from '@elliemae/ds-utilities/utils';
import { prepareItems } from './helper.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var utils = _objectSpread({
  prepareItems: function prepareItems$1(items, options) {
    return compose(tree.fixOrder(options), prepareItems)(items);
  }
}, tree);

export default utils;
//# sourceMappingURL=utils.js.map
